import i18n from 'i18next'

export const PRICING_PLANS = [
  { id: 'free', revenuecatPackageId: '', revenuecatProductId: '', price: {kzt: 0, usd: 0}, limits: {sales: {usd: 1000}} },
  { id: 'tier1', paddleId: 800039, revenuecatPackageId: 'tier_1_mo', revenuecatProductId: 'atlas_tier_1', price: {kzt: 5000,  usd: 9.99}, limits: {sales: {usd: 10000}} },
  { id: 'tier2', paddleId: 800040, revenuecatPackageId: 'tier_2_mo', revenuecatProductId: 'atlas_tier_2', price: {kzt: 10000,  usd: 19.99}, limits: {sales: {usd: 20000}} },
  { id: 'tier3', paddleId: 800041, revenuecatPackageId: 'tier_3_mo', revenuecatProductId: 'atlas_tier_3', price: {kzt: 20000,  usd: 39.99}, limits: {sales: {usd: 1000000}} },
]

export const getPlanInfo = (planId) => {
  let localizedPricingPlans = PRICING_PLANS.map(item => ({...item, text: i18n.t('pricingPlans.' + item.id + 'Name'), description: i18n.t('pricingPlans.' + item.id + 'Description')}))
  let plan = localizedPricingPlans.find(element => element.revenuecatProductId === planId)
  if (!plan) plan = localizedPricingPlans.find(element => element.revenuecatPackageId === planId)
  if (!plan) {
    let paddleIdInt = parseInt(planId)
    plan = localizedPricingPlans.find(element => element.paddleId === paddleIdInt)
  }
  if (plan) return plan  
  return localizedPricingPlans[0]
}

/**
 * The `billing.*` translation key for an organization's plan status line. ATL-1923: a term that
 * ended on a failed charge (`paymentLapsed`) is not a cancellation, so it does not read "Cancelled".
 * @param {{ paymentLapsed?: boolean, subscriptionStatus?: string } | null | undefined} subscriptionInfo
 */
export const planStatusKey = (subscriptionInfo) =>
  subscriptionInfo?.paymentLapsed ? 'billing.deletedPaymentFailed' : 'billing.' + subscriptionInfo?.subscriptionStatus

export const PRICING_MODELS = {
  freemium0: {

  },
  trial_19_08_23: {
    plans: [
      { 
        id: 'starter', order: 0, text: 'Начинающий', paddleId: 'pro_01h87aa8g5g3m8kw182y5e0yt4', revenuecatId: 'starter_mo_trial', description: 'Базовые функции для начинающих предпринимателей с доходом менее $5000 в месяц', 
        limits: {sales: {usd: 5000}, users: 2, stores: 1, modules: ['spendings', 'shift', 'transfers', 'salary', 'checklist', 'ecommerce', 'payments', 'printStickers', 'manufactures', 'clients']},
        highlights: [
          {text: 'Продажи', included: true},
          {text: 'Комплексные продажи', included: true},
          {text: 'Склад', included: true},
          {text: 'Остатки товаров', included: true},
          {text: 'Отчет по продажам', included: true},
          {text: 'Расходы', included: false},
          {text: 'Отчет по прибыли', included: false},
          {text: 'Смены', included: false},
          {text: 'Клиенты', included: false},
          {text: 'Все модули', included: false},
        ],
        supportHighlights: [
          {text: 'Доступ в базу знаний', included: true},
          {text: 'Поддержка через email', included: true},
          {text: 'Помощь с настройкой через чат', included: false},
          {text: 'Персональный менеджер', included: false}
        ],
      },
      { 
        id: 'standard', order: 1, popular: true, text: 'Стандартный', paddleId: 'pro_01h87ajje7hthd67angprbndh9', revenuecatId: 'standard_mo_trial', description: 'Стандартный план для бизнесов с доходами менее $20000 в месяц', 
        limits: {sales: {usd: 20000}, users: 5, stores: 1, modules: []},
        highlights: [
          {text: 'Продажи', included: true},
          {text: 'Комплексные продажи', included: true},
          {text: 'Склад', included: true},
          {text: 'Остатки товаров', included: true},
          {text: 'Отчет по продажам', included: true},
          {text: 'Расходы', included: true},
          {text: 'Отчет по прибыли', included: true},
          {text: 'Смены', included: true},
          {text: 'Клиенты', included: true},
          {text: 'Все модули', included: true},
        ],
        supportHighlights: [
          {text: 'Доступ в базу знаний', included: true},
          {text: 'Поддержка через email', included: true},
          {text: 'Помощь с настройкой через чат', included: false},
          {text: 'Персональный менеджер', included: false}
        ]
      },
      { 
        id: 'full', order: 2, text: 'Полный', paddleId: 'pro_01h87amgxrrz3cmqc0a81rxbep', revenuecatId: 'full_mo_trial', description: 'Полный план для бизнесов с доходами более $20000 или несколькими филиалами', 
        limits: {sales: {usd: 50000}, users: 10, stores: 2, modules: []},
        highlights: [
          {text: 'Продажи', included: true},
          {text: 'Комплексные продажи', included: true},
          {text: 'Склад', included: true},
          {text: 'Остатки товаров', included: true},
          {text: 'Отчет по продажам', included: true},
          {text: 'Расходы', included: true},
          {text: 'Отчет по прибыли', included: true},
          {text: 'Смены', included: true},
          {text: 'Клиенты', included: true},
          {text: 'Все модули', included: true},
        ], 
        supportHighlights: [
          {text: 'Доступ в базу знаний', included: true},
          {text: 'Поддержка через email', included: true},
          {text: 'Помощь с настройкой через чат', included: true},
          {text: 'Персональный менеджер', included: true}
        ]
      },
    ]
  }
}